var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.9995V5.99952C16 3.78252 14.215 1.97852 12.021 1.97852C11.9506 1.97894 11.8805 1.98733 11.812 2.00352C10.7853 2.0533 9.81693 2.49587 9.10738 3.23967C8.39783 3.98346 8.00136 4.97156 8 5.99952V11.9995C8 14.2055 9.794 15.9995 12 15.9995C14.206 15.9995 16 14.2055 16 11.9995ZM10 11.9995V5.99952C10 4.89652 10.897 3.99952 12 3.99952C12.0547 3.99953 12.1092 3.99451 12.163 3.98452C13.188 4.05952 14 4.93452 14 5.99952V11.9995C14 13.1025 13.103 13.9995 12 13.9995C10.897 13.9995 10 13.1025 10 11.9995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H4C4 16.072 7.061 19.436 11 19.931V22H13V19.931C16.939 19.436 20 16.073 20 12H18C18 15.309 15.309 18 12 18C8.691 18 6 15.309 6 12Z",
    fill: "#80E88A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneGreen);
export default __webpack_public_path__ + "static/media/microphone-green.4ad53de299665fd26844bd205f8eb4ed.svg";
export { ForwardRef as ReactComponent };